import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { Lock, Shield, Zap } from 'lucide-react';
import { PaymentIcons } from './PaymentIcons';
export function FinalCTA() {
  return <section className="py-24 bg-radial-glow-red relative border-t border-brand-cardBorder" data-id="element-25">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-27">
          <h2 className="font-serif text-4xl sm:text-5xl font-bold text-white mb-6" data-id="element-28">
            Tu momento es{' '}
            <span className="text-brand-crimson italic" data-id="element-29">ahora.</span>
          </h2>
          <p className="text-xl text-brand-text/80 mb-10 max-w-2xl mx-auto" data-id="element-30">
            No dejes que la duda te robe otro momento de intimidad. Únete a los
            hombres que ya han recuperado el control.
          </p>

          <div className="max-w-xl mx-auto" data-id="element-31">
            <CtaButton text="SÍ, QUIERO EL CÓDIGO MAESTRO CON EL 75% DE DESCUENTO" data-id="element-32" />

            <div className="mt-8 flex flex-col items-center gap-4" data-id="element-33">
              <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-brand-muted font-medium" data-id="element-34">
                <div className="flex items-center gap-2" data-id="element-35">
                  <Lock className="w-4 h-4 text-brand-gold" data-id="element-36" />
                  <span data-id="element-37">Pago 100% seguro</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-38">
                  <Zap className="w-4 h-4 text-brand-gold" data-id="element-39" />
                  <span data-id="element-40">Acceso inmediato</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-41">
                  <Shield className="w-4 h-4 text-brand-gold" data-id="element-42" />
                  <span data-id="element-43">Garantía 7 días</span>
                </div>
              </div>

              <PaymentIcons data-id="element-44" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}